import React, { useState } from "react";
import { Grid, Button, Box, Typography, CircularProgress } from "@mui/material";
import RegularizationAccordion from "@/pages/attendance/component/Accordion";
import DetailRow from "@/pages/attendance/component/DetailRow";
import DisplayDates from "@/pages/attendance/component/DisplayDates";
import renderActions from "../../component/RenderActions";
import { CustomAlert, StyledButton } from "@/components";
import { useNavigate } from "react-router-dom";
import { useApproveRegularizationMutation } from "@/api/services/attendance/regularization/EmployeeRegularization";
import FormikTextarea from "@/components/forms/FormikTextarea";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import DialogForm from "@/components/modal/DialogForm";
import { toast } from "@/components/toastify";
import Loader from "@/components/loader";

// Example styles for buttons
const styles = {
  rejectButton: {
    backgroundColor: (theme) => theme.palette.BudgieThemeColor.Error[100],
    color: (theme) => theme.palette.error.main,
    borderColor: (theme) => theme.palette.BudgieThemeColor.Error[500],
    m: (theme) => theme.spacing(0, 1),
    borderRadius: (theme) => theme.shape.s,
  },
  viewButton: {
    backgroundColor: (theme) => theme.palette.BudgieThemeColor.Primary[1200],
    color: (theme) => theme.palette.BudgieThemeColor.BaseWhite,
    m: (theme) => theme.spacing(0, 1),
    borderRadius: (theme) => theme.shape.s,
  },
  partialButton: {
    backgroundColor: (theme) => theme.palette.BudgieThemeColor.Warning[100],
    color: (theme) => theme.palette.warning.main,
    borderColor: (theme) => theme.palette.BudgieThemeColor.Warning[500],
    m: (theme) => theme.spacing(0, 1),
    borderRadius: (theme) => theme.shape.s,
  },
};

const PendingApprovals = ({ approvalsRecords, PendingRefetch, ApprovedRefetch, isLoadingPending }) => {
  const navigate = useNavigate();
  const [actionType, setActionType] = useState("");
  const [approveRegularization, { }] = useApproveRegularizationMutation();
  const appRecords = approvalsRecords || [];
  const [selectedItem, setSelectedItem] = useState(null);
  const [openApprovePopUp, setOpenApprovePopUp] = useState(false);
  const approveClose = () => setOpenApprovePopUp(false);
  const [statusLoading, setStatusLoading] = useState(false);

  // 2025-03-25
  // const attendanceStartDate = "2025-03-25";
  // const attendanceEndDate = "2025-04-25";

  const attendanceStartDate = appRecords?.data?.repoLockStartDate;
  const attendanceEndDate = appRecords?.data?.repoLockEndDate;

  const [formData, setFormData] = useState({ reason: "", });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAppClick = (item, type) => {
    setSelectedItem(item);
    setActionType(type);
    if (type === "Approved") {
      handleApproveClick(true);
    } else if (type === "Rejected") {
      handleRejectClick(true);
    }
  };

  // put call
  const handleFormSubmit = async (formData, { resetForm } = {}) => {

    const approvedDates = [];
    const rejectedDates = [];
    const approverRemarksArray = [];

    selectedItem?.appliedRegularizations?.forEach((item) => {
      if (actionType === "Approved") {
        approvedDates.push(item.attendanceDate);
      } else {
        rejectedDates.push(item.attendanceDate);
      }
    });
    if (actionType === "Rejected" && formData?.reason) {
      approverRemarksArray.push(formData.reason);
    }
    const requestData = {
      empId: selectedItem?.empId,
      regCode: selectedItem?.regularizationCode,
      key: actionType,
      approvedDate: approvedDates,
      rejectedDate: rejectedDates,
      remarks: approverRemarksArray,
    };
    setOpenApprovePopUp(false);
    setOpenDialog(false);
    setStatusLoading(true);
    try {
      await approveRegularization(requestData).unwrap();

      const toastMessage =
        actionType === "Approved" ? "Approved successfully!" : "Rejected successfully!";
      toast("success", toastMessage);

      await PendingRefetch();
      await ApprovedRefetch();
      setStatusLoading(false);
    } catch (error) {
      setStatusLoading(false);
    }
    if (resetForm) resetForm();
    // resetForm()
  };

  const formatDate = (dateString) => {
    return new Date(dateString)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .split("/")
      .join("/");
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "REG":
        return "Regularization";
      case "WFH":
        return "Work From Home";
      case "OD":
        return "On Duty";
      default:
        return "";
    }
  };

  const renderDetails = (item) => {
    const workTypes = item.appliedRegularizations
      ?.map((reg) => getStatusLabel(reg?.regularizationStatus))
      .filter((type) => type && type.trim() !== "")
      .join(", ");

    const sessionTypes = item.appliedRegularizations
      ?.map((reg) => reg.session)
      .filter((s) => s && s.trim() !== "")
      .join(", ");

    const inOutTimes = item.appliedRegularizations
      ?.map((reg) => {
        const start = reg.startTime?.slice(0, 5) || "--:--";
        const end = reg.endTime?.slice(0, 5) || "--:--";
        return `${start} - ${end}`;
      })
      .join(", ") || "-";

    const employeeReasons = item.appliedRegularizations
      ?.map((reg) => reg.reason || "-")
      .join(", ");

    return (
      <Grid container spacing={2}>
        <DetailRow label="Work Type" value={workTypes} />
        <DetailRow label="No. of days" value={item.noOfDays || "-"} />
        <DetailRow label="Sessions" value={sessionTypes} />
        <DetailRow label="Applied On" value={formatDate(item.appliedDate)} />
        <DetailRow
          label="Applied For"
          value={<DisplayDates dates={item.regularizationDates} />}
        />
        <DetailRow label="IN/OUT Time" value={inOutTimes} />
        <DetailRow label="Employee Reason" value={employeeReasons || "-"} />
        {item.remarks && item.remarks.trim() !== "" && (
          <DetailRow label="Employee Remarks" value={item.remarks} />
        )}
      </Grid>
    );
  };


  const handleApproveClick = (row) => {
    setOpenApprovePopUp(true);
  };
  const actions = (item) => {
    const startDate = new Date(attendanceStartDate);
    const endDate = new Date(attendanceEndDate);

    // Check if any attendanceDate is within the range
    const isDateWithinRange = item?.appliedRegularizations?.some(({ attendanceDate }) => {
      const date = new Date(attendanceDate);
      return date >= startDate && date <= endDate;
    });

    return [
      ...(item?.noOfDays > 1 && isDateWithinRange
        ? [
          {
            label: "Partial Approve",
            variant: "outlined",
            sx: styles.partialButton,
            hoverSx: {
              backgroundColor: (theme) =>
                theme.palette.BudgieThemeColor.Success[200],
              color: (theme) => theme.palette.success.dark,
              borderColor: (theme) =>
                theme.palette.BudgieThemeColor.Success[600],
            },
            onclick: () => {
              navigate(`/attendance/adminAttendanceRegApproved`, {
                state: { data: item },
              });
            },
          },
        ]
        : []), // Hide Partial Approve if all dates are out of range

      ...(isDateWithinRange
        ? [
          {
            label: "Approve",
            variant: "outlined",
            sx: styles.viewButton,
            hoverSx: {
              backgroundColor: (theme) =>
                theme.palette.BudgieThemeColor.Primary[1300],
              color: (theme) => theme.palette.BudgieThemeColor.BaseWhite,
              borderColor: (theme) => theme.palette.BudgieThemeColor.Primary[700],
            },
            onclick: () => {
              setActionType("Approved");
              handleAppClick(item, "Approved");
            },
          },
          {
            label: "Reject",
            variant: "outlined",
            sx: styles.rejectButton,
            hoverSx: {
              backgroundColor: (theme) =>
                theme.palette.BudgieThemeColor.Error[200],
              color: (theme) => theme.palette.error.dark,
              borderColor: (theme) => theme.palette.BudgieThemeColor.Error[600],
            },
            onclick: () => {
              setActionType("Rejected");
              handleAppClick(item, "Rejected");
            },
          },
        ]
        : []), // Hide Approve and Reject buttons if all dates are out of range
    ];
  };


  const getTitle = (item) => `${item.employeeName}(${item.empId})`;

  const [openDialog, setOpenDialog] = useState(false);

  const handleRejectClick = (row) => {
    setOpenDialog(true);
  };
  return (
    <>
      {isLoadingPending ? (
        <Loader />
      ) : (
        <RegularizationAccordion
          items={appRecords}
          renderDetails={renderDetails}
          renderActions={(item) => renderActions(item, actions(item))}
          containerSpacing={(theme) => theme.spacing(2)}
          detailsGridProps={{ xs: 12, sm: 8 }}
          actionsGridProps={{ xs: 12, sm: 4 }}
          accordionProps={{ elevation: 1 }}
          getTitle={getTitle} // Pass the function to get title
          getChipLabel={(item) => item.approvedStatus}
          getChipColor={(item) =>
            item.approvedStatus === "Approved" ? "success" : "error"
          }
          showActions={true}
        />
      )}
      <CustomAlert
        open={openApprovePopUp}
        title="Approval Request"
        message="Are you sure you want to approve the request?"
        onCancel={approveClose}
        onSubmit={handleFormSubmit}
        cancelText="Cancel"
        submitText="Submit"
        isSubmitting={statusLoading}
      />

      <DialogForm
        title="Reject Application"
        open={openDialog} // optional
        setOpen={setOpenDialog} // optional
        message={"Are you sure you want to reject this application?"}
      // dialogWidth="600px" // Set the desired width
      >
        <Formik
          initialValues={{ reason: "" }}
          validationSchema={Yup.object({
            reason: Yup.string()
              .min(5, "Reason must be at least 5 characters")
              .required("Reason is required"),
          })}
          onSubmit={handleFormSubmit}

        >
          {({ errors, touched, resetForm, isSubmitting }) => (
            <Form>

              <Grid item xs={12} sm={6}>
                <FormikTextarea
                  name="reason"
                  label="Reason"
                  placeholder="Enter your Reason"
                  required
                  onChange={handleChange}
                  width="100%"
                />
              </Grid>
              <Grid item xs={12} sx={{ textAlign: "right", paddingTop: 2 }}>
                <StyledButton type="submit" label={isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                  variant="contained" />
                {/* <Button type="submit" variant="contained" color="primary">
                  Submit
                </Button> */}
              </Grid>
            </Form>
          )}
        </Formik>
      </DialogForm>
    </>
  );
};

export default PendingApprovals;
